/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 100 to 80: ((100 − 80) ÷ 100) × 100 = 20% decrease.`)
};

const es_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 100 a 80: ((100 − 80) ÷ 100) × 100 = 20% de disminución.`)
};

const de_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 100 auf 80: ((100 − 80) ÷ 100) × 100 = 20 % Rückgang.`)
};

const nl_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 100 naar 80: ((100 − 80) ÷ 100) × 100 = 20% daling.`)
};

const fr_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 100 à 80 : ((100 − 80) ÷ 100) × 100 = diminution de 20 %.`)
};

const it_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 100 a 80: ((100 − 80) ÷ 100) × 100 = calo del 20%.`)
};

const pt_br2_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 100 para 80: ((100 − 80) ÷ 100) × 100 = 20% de diminuição.`)
};

const pt_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 100 para 80: ((100 − 80) ÷ 100) × 100 = 20% de diminuição.`)
};

const ja_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100から80へ: ((100 − 80) ÷ 100) × 100 = 20%減少。`)
};

const zh_pct_decrease_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 100 到 80：((100 − 80) ÷ 100) × 100 = 减少 20%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_ex1", locale)
	if (locale === "en") return en_pct_decrease_ex1(inputs)
	if (locale === "es") return es_pct_decrease_ex1(inputs)
	if (locale === "de") return de_pct_decrease_ex1(inputs)
	if (locale === "nl") return nl_pct_decrease_ex1(inputs)
	if (locale === "fr") return fr_pct_decrease_ex1(inputs)
	if (locale === "it") return it_pct_decrease_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_ex1(inputs)
	if (locale === "pt") return pt_pct_decrease_ex1(inputs)
	if (locale === "ja") return ja_pct_decrease_ex1(inputs)
	return zh_pct_decrease_ex1(inputs)
};